import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a6de214e47c8700146d95ea_1788253306106_c64b75de/silag_sims/src/app/page.tsx");
